import {
    Component,
    h,
    Host,
    Prop,
    Event,
    EventEmitter,
    Method,
} from "@stencil/core";

@Component({
    tag: "ux-iws-nav-burger",
    styleUrl: "navigation-burger.scss",
    shadow: false,
})
export class NavigationBurger {
    private baseClass: string = "ux-iws-nav-burger";

    /** Menu text open */
    @Prop() menuTextOpen: string = "Menu";

    /** Menu text close */
    @Prop() menuTextClose: string = "Close";

    /** Navigation open event */
    @Event({
        eventName: "uxIwsNavOpen",
        composed: true,
        cancelable: true,
        bubbles: true,
    })
    navOpen: EventEmitter;

    /** Navigation close event */
    @Event({
        eventName: "uxIwsNavClose",
        composed: true,
        cancelable: true,
        bubbles: true,
    })
    navClose: EventEmitter;

    /** Close the burger menu */
    @Method()
    public close(): Promise<void> {
        this.navClose.emit();
        return;
    }

    private navigationOpen = (e) => {
        e.stopPropagation();
        this.navOpen.emit();
    };

    private navigationClose = (e) => {
        e.stopPropagation();
        this.navClose.emit();
    };

    private handleClickMenu = (e) => {
        // close search form if opened
        const searchOpenClassName = "ux-iws-navigation-meta__search--open";
        const searchOpenElement = document.querySelector(
            `.${searchOpenClassName}`
        );
        if (searchOpenElement !== null) {
            searchOpenElement.classList.remove(searchOpenClassName);
        }
        this.navigationOpen(e);
    };

    render() {
        return (
            <Host class={`${this.baseClass}`}>
                <button
                    class={`${this.baseClass}__open`}
                    onClick={this.handleClickMenu}
                >
                    <div class="ux-iws-nav-burger__text">
                        {this.menuTextOpen}
                    </div>
                    <ux-icon name="menu" />
                </button>
                <button
                    class={`${this.baseClass}__close`}
                    onClick={(e) => this.navigationClose(e)}
                >
                    <div class="ux-iws-nav-burger__text">
                        {this.menuTextClose}
                    </div>
                    <ux-icon name="close" />
                </button>
            </Host>
        );
    }
}
